@if(isActiveClaim)
{
<app-party-overview [data]="partyOut" (onClose)="isActiveClaim=$event"></app-party-overview>
}
@else{

<app-page-header
    title="Siniestros"
    mobileTitle="Siniestros"
    icon="fas fa-car-crash"
    [showBack]="appSettings.isMobile() && !!claimOut"
    [unifiedOnMobile]="appSettings.isMobile() && !!claimOut"
    (back)="closeOverviewClaim()">
</app-page-header>

<app-mobile-footer [visible]="appSettings.isMobile() && !claimOut">
    <ng-select [items]="ngPartiesData" [selectableGroup]="true" [hideSelected]="false"
        bindLabel="rutNames" [multiple]="true" [closeOnSelect]="false" [hideSelected]="true"
        [dropdownPosition]="'top'" bindValue="id" placeholder="Buscar Socio..." tabindex="1"
        class="mobile-footer-search"
        (change)="changeSelect()" [(ngModel)]="partiesSelected">
    </ng-select>
    <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
        [class.btn-outline-primary]="mobileFilterCount > 0"
        (click)="mobileFiltersOpen = true">
        <i class="fas fa-filter me-1"></i>Filtros
        @if (mobileFilterCount > 0) {
            <span class="badge bg-primary ms-1">{{ mobileFilterCount }}</span>
        }
    </button>
</app-mobile-footer>
<app-bottom-sheet [open]="mobileFiltersOpen" title="Filtros" (closed)="mobileFiltersOpen = false">
    <div class="px-3 pb-3 d-flex flex-column gap-3">
        <div>
            <label class="form-label small text-muted mb-1">Entidad</label>
            <ng-select [items]="ngEntitydata" [selectableGroup]="true" [hideSelected]="false"
                bindLabel="description" [multiple]="true" [closeOnSelect]="false" [hideSelected]="true"
                [dropdownPosition]="'top'" bindValue="code" placeholder="Filtrar Entidad"
                [(ngModel)]="entitiesSelected" (change)="changeSelect()">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="custom-control custom-checkbox d-flex align-items-center">
                        <input type="checkbox" [ngModel]="item$.selected"
                            class="custom-control-input form-check-input me-2" />
                        <label class="custom-control-label">{{item.description}}</label>
                    </div>
                </ng-template>
                @if(entitiesSelected?.length!=entities?.length){
                <ng-template ng-header-tmp>
                    <button class="btn btn-xs btn-outline-primary" (click)="allEntities()">Todas las entidades</button>
                </ng-template>
                }
            </ng-select>
        </div>
        <div>
            <label class="form-label small text-muted mb-1">Estado</label>
            <ng-select [items]="ngStatusData" [selectableGroup]="true" [hideSelected]="false"
                bindLabel="name" [multiple]="true" [closeOnSelect]="false" [hideSelected]="true"
                [dropdownPosition]="'top'" bindValue="code" placeholder="Filtrar Estado"
                [(ngModel)]="statusSelected" (change)="changeSelect()">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="custom-control custom-checkbox d-flex align-items-center">
                        <input type="checkbox" [ngModel]="item$.selected"
                            class="custom-control-input form-check-input me-2" />
                        <label class="custom-control-label">{{item.name}}</label>
                    </div>
                </ng-template>
            </ng-select>
        </div>
    </div>
</app-bottom-sheet>

<div class="row">
    @if (!(appSettings.isMobile() && claimOut)) {
    <!-- Columna Izquierda: Filtros y Lista (3/12) -->
    <div [class]="appSettings.isMobile() ? 'col-12 mobile-requests-container' : 'col-md-3'">
        <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-2]="!appSettings.isMobile()">
            <div class="mobile-list-shell" [class.panel-body]="!appSettings.isMobile()" [class.p-2]="!appSettings.isMobile()">
                @if (!appSettings.isMobile()) {
                <!-- Filtros integrados en la columna lateral -->
                <div class="row mb-3">
                    <div class="col-12 mb-2">
                        <div class="mb-2">
                            <h4 class="m-0">Lista de Siniestros</h4>
                        </div>
                        <div class="input-group">
                            <ng-select #ngSelect [items]="ngPartiesData" [selectableGroup]="true" [hideSelected]="false"
                                bindLabel="rutNames" [multiple]="true" [closeOnSelect]="false" [hideSelected]="true"
                                [dropdownPosition]="'bottom'" bindValue="id" placeholder="Buscar Socio..." tabindex="1"
                                (change)="changeSelect()" [(ngModel)]="partiesSelected" style="flex: 1;">
                            </ng-select>
                            &nbsp;
                            <!-- Filter Dropdown -->
                            <div ngbDropdown class="d-inline-block" autoClose="outside">
                                <button class="btn btn-outline-secondary" id="dropdownFilters" ngbDropdownToggle>
                                    <i class="fas fa-filter"></i>
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdownFilters" class="p-2 dropdown-menu-end">
                                    <div class="form-check mb-1">
                                        <input class="form-check-input" type="checkbox" id="chkEntity"
                                            [(ngModel)]="showEntityFilter">
                                        <label class="form-check-label user-select-none" for="chkEntity">Entidad</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="chkStatus"
                                            [(ngModel)]="showStatusFilter">
                                        <label class="form-check-label user-select-none" for="chkStatus">Estado</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    @if(showEntityFilter){
                    <div class="col-12 mb-2 animate__animated animate__fadeIn">
                        <ng-select #ngSelect [items]="ngEntitydata" [selectableGroup]="true" [hideSelected]="false"
                            bindLabel="description" [multiple]="true" [closeOnSelect]="false" [hideSelected]="true"
                            [dropdownPosition]="'bottom'" bindValue="code" placeholder="Filtrar Entidad"
                            [(ngModel)]="entitiesSelected" tabindex="2" (change)="changeSelect()">

                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <div class="custom-control custom-checkbox d-flex align-items-center">
                                    <input type="checkbox" [ngModel]="item$.selected"
                                        class="custom-control-input form-check-input me-2" />
                                    <label class="custom-control-label">{{item.description}}</label>
                                </div>
                            </ng-template>

                            @if(entitiesSelected?.length!=entities?.length){
                            <ng-template ng-header-tmp>
                                <button class="btn btn-xs btn-outline-primary" (click)="allEntities()">Todas las
                                    entidades </button>
                            </ng-template>
                            }
                        </ng-select>
                    </div>
                    }

                    @if(showStatusFilter){
                    <div class="col-12 animate__animated animate__fadeIn">
                        <ng-select [items]="ngStatusData" [selectableGroup]="true" [hideSelected]="false"
                            bindLabel="name" [multiple]="true" [closeOnSelect]="false" [hideSelected]="true"
                            [dropdownPosition]="'bottom'" bindValue="code" placeholder="Filtrar Estado"
                            [(ngModel)]="statusSelected" tabindex="3" (change)="changeSelect()">

                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <div class="custom-control custom-checkbox d-flex align-items-center">
                                    <input type="checkbox" [ngModel]="item$.selected"
                                        class="custom-control-input form-check-input me-2" />
                                    <label class="custom-control-label">{{item.name}}</label>
                                </div>
                            </ng-template>

                        </ng-select>
                    </div>
                    }
                </div>
                }

                @if (appSettings.isMobile()) {
                <div class="d-flex justify-content-between align-items-center mb-2 px-1">
                    <span class="small text-muted fw-bold text-uppercase">
                        REGISTROS @if (!isLoading) { ({{ partiesData?.length }}) }
                    </span>
                </div>
                }

                <!-- Lista de Siniestros -->
                <div class="table-responsive table-data" [class.mobile-cards-scroll]="appSettings.isMobile()"
                    [style.max-height]="appSettings.isMobile() ? null : '60vh'">
                    <table class="table table-hover table-sm">
                        <tbody>
                            @if(isLoading){
                            @for( i of rows ;track $index){
                            <tr>
                                <td>
                                    <p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p>
                                </td>
                            </tr>
                            }
                            }
                            @if(partiesData?.length>0 && !isLoading){
                            @for(r of partiesData; track r.id; let i = $index) {
                            <tr [class.active-row]="claimOut?.id === r.id" (click)="showOverviewClaim(r)"
                                style="cursor: pointer;">
                                <td class="text-nowrap px-3">
                                    <span class="fw-bold d-block">{{ r.partyNames }}</span>
                                    <small class="text-muted">{{ r.statusName }}</small>
                                </td>
                            </tr>
                            }
                            }
                        </tbody>
                    </table>
                    @if(partiesData?.length==0 && !isLoading){
                    <div class="p-3 text-center text-muted">
                        <em>No se encontraron siniestros</em>
                    </div>
                    }
                </div>
                @if (!appSettings.isMobile()) {
                <div class="p-2 border-top text-center text-muted small">
                    Total Registros: {{partiesData?.length}}
                </div>
                }
            </div>
        </div>
    </div>
    }

    @if (!appSettings.isMobile() || claimOut) {
    <!-- Columna Derecha: Detalle (9/12) -->
    <div [class]="appSettings.isMobile() ? 'col-12' : 'col-md-9'">
        @if(claimOut){
        <app-claim-overview [data]="claimOut" (onUpdate)="getParties()"
            (onClose)="closeOverviewClaim($event)"></app-claim-overview>
        } @else {
        <div class="panel">
            <div class="panel-body d-flex flex-column align-items-center justify-content-center text-center p-5"
                style="min-height: 400px;">
                <div class="mb-3 p-4 rounded-circle bg-light d-inline-flex align-items-center justify-content-center"
                    style="width: 80px; height: 80px;">
                    <i class="fas fa-car-crash text-info fa-2x"></i>
                </div>
                <h4 class="text-muted fw-bold mb-2">No hay selección</h4>
                <div class="text-muted small">Selecciona un siniestro de la lista para ver el detalle y gestionar su
                    información.
                </div>
            </div>
        </div>
        }
    </div>
    }
</div>

}